// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-iJeD","edit-btn":"styles_edit-btn__FG3mq","loader":"styles_loader__H-0Ty"};